import { useState } from "react";
import { useCountIsUtileMutation } from "../../slices/topicsApiSlice";

const ArticleUtile = ({ id_topic }) => {
  const [countIsUtile] = useCountIsUtileMutation();
  
  const [hasVote, setHasVote] = useState(false);

  const handleVote = async (value) => {
    setHasVote(true);
    await countIsUtile({ value, id_topic });
  }

  return (
    <div className="isUtile-container">
      {!hasVote 
        ? <>
            <p className="fw-600 fz-16 mb-0">Cet article vous a-t-il été utile ?</p>
            <div className="vote-buttons">
              <p className="fw-500 fz-16 mb-0 text-underline cursor-pointer" onClick={() => handleVote(1)}>Oui</p>
              <p className="fw-500 fz-16 mb-0 text-underline cursor-pointer" onClick={() => handleVote(-1)}>Non</p>
            </div>
          </>
        : <p className="fw-600 fz-16 mb-0">Merci pour ces informations !</p>
      }
    </div>
  )
}

export default ArticleUtile